var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { classNames } from 'libs/react';
import { useMutation } from 'libs/react';
import { useState } from 'libs/react';
import { Icon } from 'components/Icon';
import { Spinner } from 'components/Spinner';
import { React } from 'libs/react';
import { useAlert } from 'components/alert/AlertStack';
import { GenerateDealMutation } from 'graphql/Deal/mutations/GenerateDealMutation';
import { GeneratePdfModal } from 'modules/deal/modal/GeneratePdfModal';
/**
 * @component PdfDownloadButton
 * @since 1.0.0
 * @hidden
 */
export function PdfDownloadButton(props) {
    const { dealId, picto = 'file-pdf', style = 'normal' } = props;
    const alert = useAlert();
    const [showModal, setShowModal] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [mutate] = useMutation(GenerateDealMutation);
    function handleConfirm(format) {
        return __awaiter(this, void 0, void 0, function* () {
            setShowModal(false);
            if (!dealId)
                return;
            setProcessing(true);
            try {
                const result = yield mutate({
                    variables: { input: { id: dealId, format } }
                });
                setTimeout(() => {
                    if (!(result === null || result === void 0 ? void 0 : result.data))
                        return;
                    const fileResult = Object.values(result.data)[0];
                    const link = document.createElement('a');
                    link.href = fileResult.filepath;
                    link.target = '_blank';
                    link.click();
                    setProcessing(false);
                }, 1200);
            }
            catch (_a) {
                setProcessing(false);
                alert.present({
                    title: t('PDF generation is currently unavailable. Please try again later.')
                });
            }
        });
    }
    const className = classNames('file-button', 'file-button--' + style, { 'file-button--is-processing': processing }, { 'file-button--has-picto': picto }, props.className);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: className, onClick: () => setShowModal(true), type: "button" },
            React.createElement(Spinner, null),
            picto && React.createElement(Icon, { className: "file-button-picto", value: picto })),
        showModal && (React.createElement(GeneratePdfModal, { onClose: () => setShowModal(false), onConfirm: handleConfirm }))));
}
